module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block",
    class: [_vm.blockClass, {
      'hover': _vm.hovering
    }],
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [_vm._t("source"), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("highlight")], 2), _vm._v(" "), _c('div', {
    staticClass: "demo-block-control",
    on: {
      "click": function($event) {
        _vm.isExpanded = !_vm.isExpanded
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hovering),
      expression: "hovering"
    }]
  }, [_vm._v(_vm._s(_vm.controlText))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-610842ce!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/components/demo-block.vue
// module id = 203
// module chunks = 1